import React from 'react';

const ManajemenWaktuCP: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Bagi setiap pegiat kompetisi pemrograman, pesan <b>Time Limit Exceeded (TLE)</b> merupakan salah satu peringatan paling mendebarkan di layar monitor juri. Kode program yang ditulis mungkin telah berhasil melewati seluruh pengujian sampel dan menghasilkan jawaban yang benar, namun tersingkir karena membutuhkan waktu komputasi sepersekian detik lebih lama dari batas waktu yang ditetapkan.
      </p>

      <p className="mb-4">
        Fenomena ini menggarisbawahi kenyataan bahwa kebenaran logika saja tidak cukup dalam dunia <i>competitive programming</i>; efisiensi algoritma adalah harga mutlak. Untuk itu, pemahaman komprehensif mengenai kompleksitas waktu (<i>Time Complexity</i>) dan notasi Big-O menjadi modal wajib bagi siapa pun yang ingin meraih prestasi di ajang kontes pemrograman.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Membedah Analisis Notasi Big-O dalam Praktek Kontes
      </h2>
      <p className="mb-4">
        Notasi Big-O memberikan estimasi matematis tentang bagaimana waktu eksekusi suatu algoritma bertumbuh seiring bertambahnya ukuran input data (N). Di sebagian besar platform kompetisi, sistem juri mengeksekusi sekitar 100 juta operasi dasar per detik (10⁸ operations/second).
      </p>

      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>N ≤ 20:</strong> Memungkinkan algoritma berwaktu eksponensial atau faktorial seperti O(2ᴺ) atau O(N!), biasanya melibatkan <i>bitmasking</i> atau pencarian menyeluruh.
        </li>
        <li>
          <strong>N ≤ 1.000:</strong> Algoritma O(N²) dapat diterima dengan aman, seperti pengurutan berbasis perbandingan sederhana atau pemrosesan matriks dua dimensi.
        </li>
        <li>
          <strong>N ≤ 100.000 hingga 1.000.000:</strong> Mengharuskan algoritma linier O(N) atau lin-logaritmik O(N log N).
        </li>
        <li>
          <strong>N ≥ 10⁹:</strong> Hanya algoritma dengan kompleksitas logaritmik O(log N) atau konstan O(1), seperti pencarian biner atau eksponensiasi modular, yang mampu menyelesaikannya tepat waktu.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Strategi Manajemen Waktu dan Psikologi Kontes
      </h2>
      <p className="mb-4">
        Selain efisiensi algoritma di tingkat mesin, efisiensi waktu peserta di depan komputer juga sangat menentukan perolehan papan skor (<i>scoreboard</i>). Peserta berpengalaman biasanya menerapkan strategi <i>triage</i> di awal sesi: membaca seluruh deskripsi soal secara menyeluruh dalam 15 menit pertama untuk memetakan tingkat kesulitan soal, kemudian menyelesaikan soal termudah terlebih dahulu untuk mengamankan poin.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Optimasi Teknis: Fast I/O dan Hindari Debugging Buta
      </h2>
      <p className="mb-4">
        Sering kali TLE terjadi bukan karena algoritma yang cacat, melainkan karena lambatnya proses pembacaan input data dari sistem I/O standar. Menggunakan instruksi <code>ios_base::sync_with_stdio(false); cin.tie(NULL);</code> pada bahasa C++ mampu mempercepat pembacaan data hingga sepuluh kali lipat.
      </p>
    </div>
  );
};

export default ManajemenWaktuCP;
